import React, { useState, useEffect } from 'react';
import { svg } from 'lib/svgList';
import { componentsViewUsers } from 'helpers/utils';
import CustomInput from 'components/CustomInput';
import { addRefRouteAction } from 'store/actions/isRouteRefActions';
import { signIn, closeErrorUser, closeDeletionRequested } from 'store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'components/Modal';
import RecoveryPasswordTemplate from './RecoveryPasswordTemplate/RecoveryPasswordTemplate';
import * as S from './Login.Styled';

function Login() {
	const dispatch = useDispatch();
	const { message, loading, deletionRequested } = useSelector((state) => state.user);
	const currentTab = useSelector((state) => state.isTabRef);

	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [modalResetPassword, setModalResetPassword] = useState(false);
	const [counter, setCounter] = useState(60);

	const formData = { email, password, ...(deletionRequested && { recover_account: true }) };

	// estado necessário para controlar a função de resetar senha
	const [emailRecoveryPassWord, setEmailRecoveryPassWord] = useState('');

	const handleSubmit = (e) => {
		e.preventDefault();
		dispatch(signIn(formData));
	};

	const handleClose = () => {
		dispatch(closeErrorUser());
	};

	useEffect(() => {
		componentsViewUsers({
			page: `plataforma/painel/login`,
			title: 'Login'
		});

		return () => {
			dispatch(closeDeletionRequested());
		};
	}, [dispatch]);

	useEffect(() => {
		let timer;
		if (deletionRequested) {
			timer = setInterval(() => {
				setCounter((prevCounter) => {
					if (prevCounter <= 1) {
						clearInterval(timer);
						dispatch(closeDeletionRequested());
						return 30; // Reset counter for future use
					}
					return prevCounter - 1;
				});
			}, 1000);
		} else {
			setCounter(60); // Reset counter if deletionRequested is false
			dispatch(closeErrorUser());
		}
		return () => clearInterval(timer);
	}, [deletionRequested]);

	return (
		<S.Container onSubmit={handleSubmit}>
			{currentTab === 'tab1' ? (
				<S.BoxLogo>
					<img src={svg.icon.aciLogo} alt="logo aci" />
				</S.BoxLogo>
			) : (
				<S.Title>PAINEL DE CONTROLE</S.Title>
			)}

			<CustomInput
				alt="email"
				src={svg.icon.userOrange}
				value={email}
				type="email"
				name="email"
				placeholder="Email"
				setValue={setEmail}
				required
			/>

			<CustomInput
				alt="password"
				src={svg.icon.padlock}
				value={password}
				type="password"
				name="password"
				placeholder="Senha"
				setValue={setPassword}
				required
			/>

			<S.ResetPassword
				onClick={() => {
					setModalResetPassword(true);
				}}
			>
				<p>Esqueceu a senha? </p>
			</S.ResetPassword>

			<Modal isOpen={modalResetPassword} setIsOpen={setModalResetPassword} useBtnEnd={false}>
				<RecoveryPasswordTemplate email={emailRecoveryPassWord} setEmail={setEmailRecoveryPassWord} />
			</Modal>

			{deletionRequested && (
				<S.Timer>
					{message} <br />
					<br />
					Tempo restante para a recuperação da conta: {counter}s
				</S.Timer>
			)}

			<S.ButtonLogin type="submit" disabled={loading}>
				{loading ? 'Aguarde...' : deletionRequested ? 'Continuar com o login' : 'Entrar'}
			</S.ButtonLogin>
			<S.ButtonRegister
				type="button"
				onClick={() => {
					dispatch(addRefRouteAction('register'));
				}}
				disabled={loading}
			>
				Cadastrar
			</S.ButtonRegister>

			<Modal isOpen={message?.length > 0 && !deletionRequested} setIsOpen={handleClose} useBtnEnd={false}>
				{message}
			</Modal>
		</S.Container>
	);
}

export default Login;
